// Semplice dizionario IT/EN — testi principali del sito.
export const TEXTS = {
  it: {
    nav: { work: "Portfolio", about: "Chi Sono", contact: "Contatti" },
    hero: {
      role: "Fotografo · Ritrattista",
      tagline: "Ritratti di barbieri, botteghe e artigiani dello stile",
      cta: "Vedi il Lavoro",
    },
    portfolio: {
      title: "Il Lavoro",
      bw: "Bianco & Nero",
      bwSub: "Il cuore del mio lavoro",
      color: "A Colori",
      colorSub: "Piccola selezione",
      loadMore: "Scopri di Più",
    },
    about: {
      title: "Chi Sono",
      kicker: "Simone Orfanò — Simon O.",
      body: [
        "Fotografo italiano specializzato in ritratti di barbieri, botteghe artigiane e persone che portano avanti un mestiere con orgoglio.",
        "Il mio linguaggio è il bianco e nero. Poca luce, poca posa, molta verità. Mi interessano le mani, le rughe, gli sguardi concentrati, gli attrezzi consumati dal tempo.",
        "Lavoro su commissione per barbieri, brand di prodotti per la barba, editori e chiunque abbia una storia di mestiere da raccontare.",
      ],
    },
    contact: {
      title: "Scrivimi",
      lead: "Per collaborazioni, servizi fotografici o semplici curiosità.",
      emailLabel: "Email",
      instagramLabel: "Instagram",
    },
    footer: {
      rights: "Tutti i diritti riservati.",
      builtWith: "Sito personale",
    },
    langLabel: "EN",
  },
  en: {
    nav: { work: "Portfolio", about: "About", contact: "Contact" },
    hero: {
      role: "Photographer · Portraitist",
      tagline: "Portraits of barbers, workshops and craftsmen of style",
      cta: "See the Work",
    },
    portfolio: {
      title: "The Work",
      bw: "Black & White",
      bwSub: "The heart of my practice",
      color: "In Color",
      colorSub: "A small selection",
      loadMore: "Discover More",
    },
    about: {
      title: "About Me",
      kicker: "Simone Orfanò — Simon O.",
      body: [
        "Italian photographer specialized in portraits of barbers, artisan shops and people who carry on a craft with pride.",
        "My language is black and white. Little light, little pose, plenty of truth. I care about hands, wrinkles, focused gazes and tools worn by time.",
        "I work on commission for barbers, beard-product brands, publishers and anyone with a craft story to tell.",
      ],
    },
    contact: {
      title: "Get in Touch",
      lead: "For collaborations, photo shoots or a simple hello.",
      emailLabel: "Email",
      instagramLabel: "Instagram",
    },
    footer: {
      rights: "All rights reserved.",
      builtWith: "Personal site",
    },
    langLabel: "IT",
  },
};
